import { DInterfacePreguntasFormulario } from '@dian-cmp/formulario';

export class DPreguntasFormulario implements DInterfacePreguntasFormulario {
    
    public MOSTRAR_PREGUNTAS:boolean = false;
    public PREGUNTAS_FORMULARIO:Array<any> = [];

}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/configuracion/dpreguntas-formulario.ts